import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'nutrient-chart',
  templateUrl: './nutrient-chart.component.html',
  styleUrls: ['./nutrient-chart.component.scss']
})
export class NutrientChartComponent implements OnInit {

  //https://github.com/FERNman/angular-google-charts
  // https://developers.google.com/chart/interactive/docs/gallery/combochart

  chartType = "BarChart";
  @Input() data: any;
  @Input() title: string;
  @Input() quantityLabel: string;
  @Input() columnNames: [];
  @Input() keys: [];

  @Input() options: any;
  @Input() roles: any;

  constructor() { }

  ngOnInit() {
  }

  onSelect(event) {
    if (this.keys) {
      console.log('Event:' + JSON.stringify(event));
      console.log('user clicked key at: ' + this.keys[event[0].row]);
    }
  }

}
